import React from 'react';
import { IComponentHot, IComponentHotOne } from '../../component';
import classNames from 'classnames';
import { style } from '../../utils/image';
import { getScrollCls, navigatorTo } from '../../utils/util';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import './AllForHot.scss';
import '../common.scss';
import useHot from './useHot';

// tId: string; // 唯一标示
// image: string;
// link: IComponentLink;
// desc: string;

export default function AllForHot(props: IComponentHot) {
  const { template, title } = props;
  const { setBigIndex, borderColor, h1Color, bigIndex, bigList, displayList } = useHot(
    props
  );
  return (
    <div className={'all-for-hot decoratev2-comp-com'}>
      <div className="row-wrapper" style={{ color: h1Color }}>
        {title && (
          <p className="title" style={{ color: h1Color }}>
            {title}
          </p>
        )}
        <div className={classNames('hot-list', getScrollCls(), template)}>
          {displayList.map((one, index) => (
            <div
              className={'list-one'}
              key={index}
              onClick={() => {
                // 跟珊婷确认，Hot组件只做跳转
                if (one.link && one.link.type) navigatorTo(one.link);
              }}
            >
              <img
                src={style(
                  one.image,
                  template === 'template1' ? 'wx_375_375_square' : 'wx_180_120'
                )}
                className={'one-photo'}
                style={{ border: `1px solid ${borderColor}` }}
              />
              {template === 'template1' ? (
                <div className={'one-name'}>{one.desc}</div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
      <SimpleBigPic
        pageType="HotList"
        index={bigIndex}
        list={bigList}
        setIndex={setBigIndex}
        showDetail={true}
      />
    </div>
  );
}
